import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// @ts-ignore - css import handled via CDN verbatim in index.html for Pages win32 recovery
import './index.css'
import { Toaster } from 'sonner'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster position="top-center" richColors closeButton />
  </React.StrictMode>,
)
